import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/sse`;
export const SSE_REGISTER_URL = `${API_URL}/register`;

export const triggerEvent = (payload: any, eventType = "message") =>
  axios.post(`${API_URL}/event/${eventType}`, payload).then(response => response.data);
